import l from 'constants/localizationLabels';

export enum ObjectTypeEnum {
    Campaign = 0,
    Workflow = 1,
    Template = 2,
    Segment = 3,
    EmailProvider = 4,
    AdHocReport = 5,
    SmsProvider = 6,
    CompositeReport = 7,
    WorkflowReport = 8,
    Award = 9,
}

export const ObjectTypeIconsWithTitle = {
    [ObjectTypeEnum.Segment]: { icon: 'bc-icon-segment', title: l.Segment },
    [ObjectTypeEnum.Template]: { icon: 'bc-icon-template', title: l.Template },
    [ObjectTypeEnum.Campaign]: { icon: 'bc-icon-campaign', title: l.Campaign },
    [ObjectTypeEnum.Award]: { icon: 'bc-icon-bonus', title: l.Award },
    [ObjectTypeEnum.Workflow]: { icon: 'bc-icon-customer-journey', title: l.RealtimePromotion },
};
